import React from 'react'

const BrandingIcon = (props) => {
  const height = props.height || 20
  const width = props.width || 20
  const color = props.color || '#202020'
  const strokeWidth = props.strokeWidth || '1'
  return (
    <svg width={width} height={height} viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <title>bot copy</title>
      <g id="admin-UI" stroke="none" strokeWidth={strokeWidth} fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g id="Admin-BOT-UI_branding" transform="translate(-36, -310)" stroke={color}>
          <g id="left" transform="translate(17.5, 101)">
            <g id="Group-9" transform="translate(0, 209)">
              <g id="agents-copy" transform="translate(13.5, 0)">
                <g id="bot-copy" transform="translate(8.125, 2.4999)">
                  <g id="Group-3">
                    <g id="Group-2" transform="translate(0, 3.1251)">
                      <path d="M0.508098653,1.41954349 L1.77549836,0 L1.77549836,0 L3.01099574,1.42473336 C3.32637508,1.78841804 3.5,2.25365144 3.5,2.73503557 L3.5,15.75 C3.5,16.7164983 2.71649831,17.5 1.75,17.5 C0.783501688,17.5 1.18361906e-16,16.7164983 0,15.75 L-8.8817842e-16,2.75154588 C-9.48350179e-16,2.26020618 0.180865826,1.78605867 0.508098653,1.41954349 Z" id="Rectangle"></path>
                      <line x1="0" y1="14.5940405" x2="3.5" y2="14.5940405" id="Path-2"></line>
                    </g>
                    <path d="M1.45833335,22.5000895 C1.45833335,23.8808014 2.5776215,25 3.95833335,25 L21.4583334,25 C22.8390457,25 23.9583334,23.8808014 23.9583334,22.5000895 L23.9583334,9.78758923 C23.9588618,9.12128349 23.6933831,8.48233468 23.2208338,8.01258919 L15.9458337,0.737589027 C15.4760882,0.265039769 14.8371394,-0.000438960416 14.1708336,0 L3.95833335,0 C2.73275123,0 1.95778457,0.450632717 1.63343337,1.35189488" id="Path"></path>
                    <path d="M23.4583339,8.75008921 L17.7083337,8.75008921 C16.3276218,8.75008921 15.2083337,7.63080106 15.2083337,6.25008915 L15.2083337,0.500089021" id="Path"></path>
                    <g id="Group-4" transform="translate(7.5, 12.5)">
                      <line x1="0" y1="0.416666676" x2="10.0000002" y2="0.416666676" id="Path-3"></line>
                      <line x1="0" y1="3.75000009" x2="10.0000002" y2="3.75000009" id="Path-3-Copy"></line>
                      <line x1="0" y1="7.08333349" x2="10.0000002" y2="7.08333349" id="Path-3-Copy-2"></line>
                    </g>
                  </g>
                  <g id="Group" transform="translate(8.125, 5.0001)">
                    <line x1="3.75" y1="0" x2="0" y2="3.75" id="Path-4"></line>
                    <line x1="3.75" y1="0" x2="0" y2="3.75" id="Path-4-Copy" transform="translate(1.875, 1.875) scale(-1, 1) translate(-1.875, -1.875)"></line>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default BrandingIcon





